module.exports = __webpack_public_path__ + "img/ip-pic.7925975b.png";